// @flow
import React from 'react';
import CancellationMessage from '../CancellationMessage/CancellationMessage';
import {UnitMessage} from '@homeaway/react-urgency-messaging';

import type {BadgeShape as Badge} from '../Hit/Hit';

type Props = {
    freeCancellationBadge: ?Badge,
    unitMessage: mixed
};

const UrgencyMessage = ({unitMessage, freeCancellationBadge}: Props) => {
    if (freeCancellationBadge) {
        return (
            <CancellationMessage
                freeCancellationBadge={freeCancellationBadge}
            />
        );
    }
    return (
        <UnitMessage
            className="HitInfo__content--urgency"
            size="s"
            unitMessage={unitMessage}
            ariaHidden
        />
    );
};

export default UrgencyMessage;
